import { render, staticRenderFns } from "./IntSlides.vue?vue&type=template&id=663bed44&scoped=true&"
import script from "./IntSlides.vue?vue&type=script&lang=js&"
export * from "./IntSlides.vue?vue&type=script&lang=js&"
import style0 from "./IntSlides.vue?vue&type=style&index=0&id=663bed44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bed44",
  null
  
)

export default component.exports